import React, { Component } from 'react'
import ListPushNotificationCounters from '../../Services/Queries/ListPushNotificationCounters'
import { Button, Table, Modal } from 'react-bootstrap'
import GetContentCategories from '../../Services/Queries/GetContentCategories'
import { DateRangePicker } from 'react-date-range'
import Header from '../header'
import Spinner from '../header/Spinner'
import { PNCountersHeadings, slots, weekdays } from '../Data/StaticData'

class ListPNCounters extends React.Component {
	constructor(props) {
		super(props)
		this.dayName = weekdays
		this.slots = slots
		this.state = {
			// timeFilter: true,
			dateRangeSelection: {
				fromTime: new Date(new Date().setHours(0, 0, 0, 0)),
				toTime: new Date(new Date().setHours(23, 59, 59, 999)),
			},
			showDatePicker: false,
			showDatePickerAtToTime: false,
			dayName: '',
			// contentLanguageOptions: [
			// 	{
			// 		label: 'English',
			// 		value: 'En',
			// 		id: 0,
			// 	},
			// 	{
			// 		label: 'Telugu',
			// 		value: 'Te',
			// 		id: 1,
			// 	},
			// 	{
			// 		label: 'Hindi',
			// 		value: 'Hi',
			// 		id: 2,
			// 	},
			// ],
			contentCategory: '',
			categories: [],
			contentSelectedLangVal: '',
			listPNCounters: [],
			headings: PNCountersHeadings,
			modalVisible: false,
			dataFound: false,
			pnTypeCounts: {},
			slot: '',
			appLanguage: '',
			loading: false,
			startDateChanged: false,
			endDateChanged: false
		}
	}

	componentDidMount = async () => {
		let appLanguage = localStorage.getItem('appLanguage')
		appLanguage = appLanguage ? appLanguage : "Telugu"

		this.setState({ appLanguage: appLanguage }, async () => {
			await this.ListPushNotificationCounters()
			const data = await GetContentCategories()
			this.setState({ categories: data.categoriesConfig, })
		})

	}
	ListPushNotificationCounters = async () => {
		this.setState({ loading: true })
		let count1 = 0,
			count2 = 0,
			count3 = 0
		const input = {
			filters: {
				day: this.state.dayName,
				contentLanguage: this.state.appLanguage,
				contentCategory: this.state.contentCategory,
				slot: this.state.slot,
			},
		}
		// if (this.state.timeFilter === true) {
		input.filters.time = {}
		if (this.state.dateRangeSelection.fromTime !== '') {

			const startDate = this.getFormattedDateTime(this.state.dateRangeSelection.fromTime, 'input')
			input.filters.time.fromTime = startDate
		}
		if (this.state.dateRangeSelection.toTime !== '') {
			const endDate = this.getFormattedDateTime(this.state.dateRangeSelection.toTime, 'input')
			input.filters.time.toTime = endDate
		}
		// }
		console.log(input, 'input firstt========')
		const listPNCounters = await ListPushNotificationCounters(input)
		console.log(listPNCounters, listPNCounters.items, 'listPNCounters=====')
		if (
			listPNCounters.items !== null &&
			listPNCounters.items !== undefined &&
			listPNCounters.items.length > 0
		) {
			for (const item of listPNCounters.items) {
				if (item.type === 'topStories') {
					count1 = count1 + 1
				} else if (item.type === 'regularTopic') {
					count2 = count2 + 1
				} else if (item.type === 'Major') {
					count3 = count3 + 1
				}
			}
			this.setState({ dataFound: true })
		} else {
			this.setState({ dataFound: false })
		}

		this.setState({
			loading: false,
			listPNCounters: listPNCounters.items,
			pnTypeCounts: { topStoriesCount: count1, regularTopic: count2, major: count3 },
		})
	}
	openDatePickerAtStartDate = () => {
		this.setState({ showDatePicker: true, showDatePickerAtToTime: false })
	}
	openDatePickerAtEndDate = () => {
		this.setState({ showDatePickerAtToTime: true, showDatePicker: false })
	}
	handleStartDate = (dateTime) => {
		var newStartDate = dateTime.range1.startDate
		var newEndDate = dateTime.range1.endDate
		const startDateTime = new Date(newStartDate)
		const endDateTime = new Date(newEndDate)
		startDateTime.setHours(0, 0, 0, 0)
		endDateTime.setHours(23, 59, 59, 999)

		this.setState({
			dateRangeSelection: {
				fromTime: startDateTime,
				toTime: endDateTime
			},
			// timeFilter: true,
			showDatePicker: false,
			startDateChanged: true,
			endDateChanged: true
		})
	}
	handleEndDate = (dates) => {
		const currentTime = new Date()
		const start = new Date(dates.range1.startDate)
		start.setHours(0, 0, 0, 0)
		const end = new Date(dates.range1.endDate)
		end.setHours(23, 59, 59, 999)
		if ((this.state.dateRangeSelection.fromTime.toString().split(':')[0] === currentTime.toString().split(':')[0]) || (this.state.dateRangeSelection.fromTime.getTime() > end)) {
			this.setState({
				startDateChanged: true,
				endDateChanged: true,
				dateRangeSelection: {
					fromTime: start,
					toTime: end
				},
				// timeFilter: true,
				showDatePickerAtToTime: false,
				showDatePicker: false,
			})
		}
		else {
			this.setState({
				endDateChanged: true,
				dateRangeSelection: {
					fromTime: this.state.dateRangeSelection.fromTime,
					toTime: end
				},
				// timeFilter: true,
				showDatePickerAtToTime: false,
			})
		}

	}
	getFormattedDateTime = (dateTime, input) => {
		var date = dateTime.getDate()
		var month = dateTime.getMonth() + 1
		var year = dateTime.getFullYear()
		var getTime = dateTime.getTime()
		var time = new Date(getTime)
		var hours = time.getHours()
		var minutes = time.getMinutes()
		if (date < 10) {
			date = '0' + date
		}
		if (month < 10) {
			month = '0' + month
		}
		var d = 'AM'
		// var h = hh
		if (hours >= 12) {
			var displayHours = hours - 12
			d = 'PM'
		} else {
			displayHours = hours
		}
		if (hours == 0) {
			hours = '00'
			displayHours = 12
		}
		minutes = minutes < 10 ? '0' + minutes : minutes
		const formattedDateTime =
			date + '/' + month + '/' + year + ' ' + displayHours + ':' + minutes + ' ' + d
		const formattedDateTime1 = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':00'
		if (input && input == 'input') {
			return formattedDateTime1
		} else {

			return formattedDateTime
		}
	}
	selectDay = (e) => {
		const dayName = e.target.value
		if (e.target.value === 'None') {
			this.setState({ dayName: '' })
		} else {
			this.setState({ dayName: dayName })
		}
	}
	selectSlot = (value) => {
		if (value === 'None') {
			this.setState({ slot: null })
		} else {
			this.setState({ slot: value })
		}
	}
	changeContentLanguage = (currentLanguage, language) => {
		this.setState({ contentSelectedLangVal: language })
	}
	closeModal = () => {
		this.setState({ modalVisible: false })
	}
	resetFilter = async () => {
		this.setState({
			dateRangeSelection: {
				fromTime: new Date(new Date().setHours(0, 0, 0, 0)),
				toTime: new Date(new Date().setHours(23, 59, 59, 999)),
			},
			dayName: '',
			contentSelectedLangVal: '',
			contentCategory: '',
			// timeFilter: true,
			showDatePicker: false,
			showDatePickerAtToTime: false,
			dataFound: false,
			slot: '',
		})
	}
	renderTable = (heading, listPNCounters) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{heading.map((head) => (
							<th class='tableRowStyle'>{head}</th>
						))}
					</tr>
				</thead>
				<tbody>{listPNCounters && listPNCounters.map((row) => this.renderTableRow(row))}</tbody>
			</Table>
		)
	}
	renderTableRow = (item) => {
		let day = item.Day ? item.Day.charAt(0).toUpperCase() + item.Day.slice(1) : null
		return (
			<tr>
				<td class='width300'>{item.contentID}</td>
				<td class='width300'>{item.contentTitle}</td>
				<td class='width300'>
					{item.pnTitle || item.pnTitle_Te || item.pnTitle_Hi || item.pnTitle_En}
				</td>
				<td class='width300'>
					{item.pnDescription ||
						item.pnDescription_Te ||
						item.pnDescription_Hi ||
						item.pnDescription_En}
				</td>
				<td class='width100'>{item.PNOpenedCount}</td>
				<td class='width100'>{item.sentPNTo}</td>
				<td class='width100'>{item.type}</td>
				<td class='width100'>{item.PNSlot}</td>
				<td class='width100'>{item.PNHour}</td>
				<td class='width100'>{item.contentCategory1}</td>
				<td class='width100'>{item.contentCategory2}</td>
				<td class='width100'>{item.contentCategory3}</td>
				<td class='width100'>{item.contentLanguage}</td>
				<td class='width300'>{item.creatorUUID}</td>
				<td class='width100'>{item.creatorHandle}</td>
				<td class='width100'>{item.videoID}</td>
				<td class='width100'>{day}</td>
				<td class='width100'>{item.DateTime}</td>
			</tr>
		)
	}

	renderCategories = () => {
		const { categories } = this.state
		return (
			<div className='row'>
				<div>
					<text for='text'>Selected Categories : </text>
					<text>{this.state.contentCategory}</text>
				</div>
				<div>
					{categories.map((category, categoryIndex) => (
						<section class='container'>
							{category.options ? (
								<div key={categoryIndex} class='ac'>
									<input
										class='ac-input'
										id={category.heading + category.id + categoryIndex}
										name={category.heading + category.id + categoryIndex}
										type='checkbox'
									/>
									<label class='ac-label' for={category.heading + category.id + categoryIndex}>
										{category.heading}
									</label>
									<article class='ac-text'>
										{category.options &&
											category.options.map((level, levelIndex) => (
												<div key={levelIndex}>
													{level.options ? (
														<div class='ac-sub'>
															<input
																class='ac-input'
																id={level.heading + category.heading + levelIndex}
																name={level.heading + category.heading + levelIndex}
																type='checkbox'
															/>
															<label
																class='ac-label'
																for={level.heading + category.heading + levelIndex}
															>
																{level.heading}
															</label>

															{level.options &&
																level.options.map((sublevel, sublevelIndex) => (
																	<article key={sublevelIndex} class='ac-sub-text'>
																		<p
																			onClick={
																				() =>
																					this.setItemSelected(
																						category.heading,
																						level.heading,
																						sublevel.heading
																					)
																				// this.setState({ contentCategory: sublevel.heading })
																			}
																		>
																			{sublevel.heading}
																		</p>
																	</article>
																))}
														</div>
													) : (
														<label
															onClick={
																() => this.setItemSelected(category.heading, level.heading, '')
																// this.setState({ contentCategory: level.heading })
															}
															for={level.heading + category.heading + levelIndex}
														>
															{level.heading}
														</label>
													)}
												</div>
											))}
									</article>
								</div>
							) : (
								<label
									onClick={
										() => this.setItemSelected(category.heading, '', '')
										// this.setState({ contentCategory: category.heading })
									}
									for={category.heading + category.id + categoryIndex}
								>
									{category.heading}
								</label>
							)}
						</section>
					))}
				</div>
			</div>
		)
	}
	setItemSelected = (category, level, sublevel) => {
		const categoryData = category ? category : ''
		const levelData = level && level != 'All' ? level : ''
		const sublevelData = sublevel && sublevel != 'All' ? sublevel : ''
		const selectedCategory =
			sublevelData != '' ? sublevelData : levelData != '' ? levelData : categoryData
		this.setState({ contentCategory: selectedCategory.trim() })
	}
	changeAppLanguage = async (e) => {
		this.setState({ loading: true })
		const { appLanguage } = this.state
		const language = e.target.value
		if (language && appLanguage != language) {
			this.setState({ appLanguage: language }, async () => {
				await this.ListPushNotificationCounters()
			})
			localStorage.setItem("appLanguage", language);
		}

	}
	render() {
		const {
			dayName,
			dateRangeSelection,
			contentSelectedLangVal,
			contentLanguageOptions,
			listPNCounters,
			headings,
			modalVisible,
			showDatePicker,
			showDatePickerAtToTime,
			dataFound,
			pnTypeCounts,
			slots,
			loading
		} = this.state
		const tableStyle = {
			border: '1px solid grey',
			fontSize: '14px',
			padding: '5px',
		}

		return (
			<section className='feed'>
				<Header changeAppLanguage={this.changeAppLanguage} appLanguage={this.state.appLanguage} />
				<div>
					<label>Push Notification Counters</label>
				</div>

				<div>
					<div class='row0' style={{ marginBottom: 5 }}>
						<div style={{ display: 'inline' }}>
							<text>Start Date : </text>
							<input
								type='text'
								onClick={() => {
									this.openDatePickerAtStartDate()
								}}
								value={this.getFormattedDateTime(dateRangeSelection.fromTime)}
								placeholder='Choose Start Date'
							></input>

						</div>
						<div style={{ display: 'inline' }}>
							<text style={{ marginLeft: 50 }}>End Date : </text>
							<input
								type='text'
								onClick={() => {
									this.openDatePickerAtEndDate()
								}}
								value={this.getFormattedDateTime(dateRangeSelection.toTime)}
								placeholder='Choose End Date'
							></input>

						</div>
						{showDatePicker ? (
							<DateRangePicker ranges={[dateRangeSelection]} onChange={this.handleStartDate} />
						) : null}
						{showDatePickerAtToTime ? (
							<DateRangePicker ranges={[dateRangeSelection]} onChange={this.handleEndDate} />
						) : null}
					</div>
					<div class='row' style={{ marginBottom: 5 }}>
						<div>
							<text for='slots'>Choose Slot : </text>
							<select
								onChange={(e) => {
									this.selectSlot(e.target.value)
								}}
							>
								{this.slots.map((item, index) => {
									return (
										<option value={item} selected={slots == item ? true : false}>
											{item}
										</option>
									)
								})}
							</select>
						</div>
					</div>
					<div class='row1' style={{ marginBottom: 5 }}>
						<div>
							<text for='dayName'>Day : </text>
							<select
								onChange={(e) => {
									this.selectDay(e)
								}}
							>
								{this.dayName.map((item, index) => {
									return (
										<option value={item} selected={dayName == item ? true : false}>
											{item}
										</option>
									)
								})}
							</select>
						</div>
					</div>

					{dataFound === true ? (
						<div class='row3' style={{ marginBottom: 5 }}>
							<table style={{ float: 'right', marginBottom: 5 }}>
								<tr style={tableStyle}>
									<th style={tableStyle}>{'Regular Topic'}</th>
									{/* <th style={tableStyle}>{'Major'}</th> */}
									<th style={tableStyle}>{'Top Stories'}</th>
								</tr>
								<tr style={tableStyle}>
									<td style={tableStyle}>{this.state.pnTypeCounts.regularTopic}</td>
									{/* <td style={tableStyle}>{this.state.pnTypeCounts.major}</td> */}
									<td style={tableStyle}>{this.state.pnTypeCounts.topStoriesCount}</td>
								</tr>
							</table>
						</div>
					) : null}
					<div class='row3' style={{ marginBottom: 5 }}>
						<text>Content Category : </text>
						<input
							type='text'
							onClick={() => {
								this.setState({ modalVisible: true })
							}}
							value={this.state.contentCategory}
							placeholder='Choose Category'
						></input>
						<Modal show={modalVisible} onHide={() => this.closeModal()}>
							<Modal.Body>{this.renderCategories()}</Modal.Body>
							<Modal.Footer>
								<Button onClick={() => this.closeModal()}>Ok</Button>
							</Modal.Footer>
						</Modal>
					</div>

					<div class='row4' style={{ marginBottom: 5 }}>
						<Button
							style={{ marginRight: 10 }}
							onClick={() => {
								this.ListPushNotificationCounters()
							}}
						>
							Filter
						</Button>
						<Button
							style={{ marginRight: 10 }}
							onClick={() => {
								this.resetFilter()
							}}
						>
							Reset
						</Button>
					</div>
				</div>
				{loading ?
					<Spinner /> : null
				}

				{dataFound === true ? (
					<div style={{ marginTop: 10 }}>{this.renderTable(headings, listPNCounters)}</div>
				) : (
					<div>No Data To Display</div>
				)}
			</section>
		)
	}
}

export default ListPNCounters
